import { useContext } from "react";
import { CheckoutSessionCtx } from "./CheckoutSessionCtx";

export function useCheckoutSessionCtx() {
  return useContext(CheckoutSessionCtx);
}
